import { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import RFField from "../../../Form/RFField";
import RFForm from "../../../Form/RFForm";
import { useEditorContext } from "../../Wysiwyg";
import ToolbarItem from "../ToolbarItem";
import { getSelectedAttributes } from "../../utils/getSelectedAttributes";

const DEFAULT_COLOR = "#000000";

const ToolbarColor = () => {
  const { editor } = useEditorContext();

  const [modal, setModal] = useState(false);
  const [color, setColor] = useState(DEFAULT_COLOR);

  const currentColor = useCurrentColor(editor);

  const toggle = () => {
    setModal(!modal);
    setColor(currentColor || DEFAULT_COLOR);
  };

  const handleSubmit = () => {
    editor.chain().focus().setColor(color).run();

    toggle();
  };

  return (
    <>
      <ToolbarItem
        id={`highlight-toolbar-item`}
        tooltip={`Betűszín`}
        active={false}
        onToggle={toggle}
        style={{ height: "28px" }}
        icon={
          <div style={{ position: "relative" }}>
            <i
              className="fa fa-font"
              aria-hidden="true"
              style={{ marginBottom: 4 }}
            />
            <div
              style={{
                position: "absolute",
                bottom: 0,
                left: -4,
                right: -4,
                height: "3px",
                backgroundColor: currentColor,
              }}
            />
          </div>
        }
      />

      <Modal isOpen={modal} toggle={toggle} backdrop="static">
        <RFForm onSubmit={handleSubmit}>
          <ModalHeader toggle={toggle}>Betűszín</ModalHeader>
          <ModalBody>
            <RFField
              id="color"
              name="color"
              type="color"
              label="Szín"
              value={color}
              onChange={(e, v) => setColor(v)}
              required
            />
          </ModalBody>
          <ModalFooter>
            <Button color="primary">OK</Button>{" "}
            <Button color="secondary" onClick={toggle}>
              Mégsem
            </Button>
          </ModalFooter>
        </RFForm>
      </Modal>
    </>
  );
};

function useCurrentColor(editor) {
  const allCurrentTextStyleAttrs = getSelectedAttributes(
    editor.state,
    "textStyle"
  );
  const isTextStyleAppliedToEntireSelection = !!editor?.isActive("textStyle");
  const currentColors = allCurrentTextStyleAttrs.map(
    (attrs) => attrs.color || DEFAULT_COLOR
  );
  if (!isTextStyleAppliedToEntireSelection) {
    currentColors.push(DEFAULT_COLOR);
  }
  const numUniqueCurrentColors = new Set(currentColors).size;

  let currentColor;
  if (numUniqueCurrentColors === 1) {
    currentColor = currentColors[0];
  } else if (numUniqueCurrentColors > 1) {
    currentColor = "";
  } else {
    currentColor = DEFAULT_COLOR;
  }

  return currentColor;
}

export default ToolbarColor;
